/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S8_TitleInputs */

const en_fc_tut_s8_title = /** @type {(inputs: Fc_Tut_S8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mix your audio`)
};

/**
* | output |
* | --- |
* | "Mix your audio" |
*
* @param {Fc_Tut_S8_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s8_title = /** @type {((inputs?: Fc_Tut_S8_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S8_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s8_title(inputs)
});
export { fc_tut_s8_title as "fc.tut.s8.title" }